import React, { useEffect, useState } from "react";
import axios from "axios";
import { Pie } from "react-chartjs-2";
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from "chart.js";
import { API_ENDPOINT } from "../../../../services/api/resources";
import classes from "./charts.module.css";
import { useSelector } from "react-redux";

ChartJS.register(ArcElement, Tooltip, Legend);

const VendorStatusPie = () => {
  const [statusData, setStatusData] = useState(null);
  const Data = useSelector((state) => state.loginData.value);
  // const org_token = Data?.organization_token;
  const user_token = Data?.user?.token || Data?.user_token;

  useEffect(() => {
    axios
      .post(API_ENDPOINT.vendor_invoice_status_summary, {
        org_token: user_token,
      })
      .then((res) => {
        setStatusData(res.data);
      });
  }, []);

  if (!statusData) return <p>Loading chart...</p>;

  const chartData = {
    labels: ["Signed", "Unsigned", "Approved", "Rejected"],
    datasets: [
      {
        label: "Vendors",
        data: [
          statusData.signed,
          statusData.unsigned,
          statusData.approved,
          statusData.rejected,
        ],
        backgroundColor: [
          "rgba(75, 192, 192, 0.6)",
          "rgba(255, 206, 86, 0.6)",
          "rgba(54, 162, 235, 0.6)",
          "rgba(255, 99, 132, 0.6)",
        ],
        borderColor: [
          "rgba(75, 192, 192, 1)",
          "rgba(255, 206, 86, 1)",
          "rgba(54, 162, 235, 1)",
          "rgba(255, 99, 132, 1)",
        ],
        borderWidth: 1,
      },
    ],
  };

  const options = {
    responsive: true,
    plugins: {
      legend: {
        position: "top",
      },
      title: {
        display: false,
        text: "Merchant Invoice Status",
      },
    },
  };

  return (
    <div className={classes.invoiceChartWrapper} style={{ marginTop: "10px" }}>
      <div className={classes.chartHeader}>
        <h2 className={classes.chartTitle}>Merchant Invoice Status</h2>
      </div>
      <div className={classes.chartContainer}>
        <Pie
          data={chartData}
          options={{ ...options, maintainAspectRatio: false }}
        />
      </div>
    </div>
  );
};

export default VendorStatusPie;
